import {phoneSvg as Icon__small__phoneSvg} from '../Icon__small/Icon__small--phone.js';

export var phone = {
  name: 'phone',
  category: 'icon',
  colorable: true,
  svg: Icon__small__phoneSvg,
};
